<template>
  <div>
    <headTop />
    <mainContent />
    <footerBottom />
    <contact />
  </div>
</template>

<script>
import headTop from "./components/head.vue";
import mainContent from "./components/main.vue";
import footerBottom from "./components/footer.vue";
import contact from "./components/contact.vue";
export default {
  components: { headTop, mainContent, footerBottom, contact },
  // components: { headTop, mainContent, footerBottom },
};
</script>
